// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-pane {
  z-index: 1;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}

.slide-pane--animated {
  transition: left .4s linear;
  left: 100%;
}

.slide-pane--open {
  left: 0;
}

.slide-pane__close {
  border-bottom: 1px solid #dcdcdc;
  align-items: center;
  height: 40px;
  font-size: 11px;
  font-weight: bold;
  display: flex;
}

.slide-pane__close button {
  background: none;
  border: none;
  padding: 0;
}

.slide-pane__close button:hover {
  color: #4f80bd;
}

.slide-pane__close button:focus {
  outline: none;
}

.slide-pane__close button .fa {
  margin-right: 10px;
  font-size: 8px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/SlidePane/styles.css","webpack://./services/frontend/app/components/SlidePane/styles.css"],"names":[],"mappings":"AADA;ECEE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".slide-pane {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  width: 100%;\n}\n\n.slide-pane--animated {\n  transition: left linear 400ms;\n  left: 100%;\n}\n\n.slide-pane--open {\n  left: 0;\n}\n\n.slide-pane__close {\n  height: 40px;\n  border-bottom: 1px solid #dcdcdc;\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.slide-pane__close button {\n    background: none;\n    border: none;\n    padding: 0;\n  }\n\n.slide-pane__close button:hover {\n      color: #4f80bd;\n    }\n\n.slide-pane__close button:focus {\n      outline: none;\n    }\n\n.slide-pane__close button .fa {\n      margin-right: 10px;\n      font-size: 8px;\n    }\n",".slide-pane {\n  z-index: 1;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.slide-pane--animated {\n  transition: left .4s linear;\n  left: 100%;\n}\n\n.slide-pane--open {\n  left: 0;\n}\n\n.slide-pane__close {\n  border-bottom: 1px solid #dcdcdc;\n  align-items: center;\n  height: 40px;\n  font-size: 11px;\n  font-weight: bold;\n  display: flex;\n}\n\n.slide-pane__close button {\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n.slide-pane__close button:hover {\n  color: #4f80bd;\n}\n\n.slide-pane__close button:focus {\n  outline: none;\n}\n\n.slide-pane__close button .fa {\n  margin-right: 10px;\n  font-size: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
